import React from "react";
import ModalBaseView from "../../../../../../../common-deprecated/components/modals/aem/lexus/ModalBaseView";
import * as Modal from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import DetailedTyreSlider from "./DetailedTyreSlider";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { DetailedTyreInfoModalType } from "../../../../../../../shared-logic/utils/tyreInfoContants";

const DetailedTyreInfoModal = (props: ModalViewType<DetailedTyreInfoModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { tyres, tyreInfoLabels } = modalSettings;

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>{tyreInfoLabels.tyreInfo}</Modal.Title>
                <Modal.Button onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Type.Text as="p">{tyreInfoLabels.tyreInfoDescription}</Type.Text>
                {tyres.length > 0 ? (
                    <DetailedTyreSlider tyres={tyres} tyreInfoLabels={tyreInfoLabels} />
                ) : (
                    <Type.Text as="p">{tyreInfoLabels.tyreInfoNoEprelFallback}</Type.Text>
                )}
            </Modal.Body>
        </ModalBaseView>
    );
};

export default DetailedTyreInfoModal;
